import { PalletteProps } from '../../../types/theme/pallette';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const Title = styled.p`
  font-size: 1rem;
  margin-right: 4px;
  font-weight: 700;
`;

export const Price = styled.p`
  font-size: .875rem;
  span {
    background-color: ${({ theme }: PalletteProps) => theme.orderDeliveryTypeColor};
    border-radius: 10px;
    padding: 2px 7px;
    margin-left: 5px;
    color: ${({ theme }: PalletteProps) => theme.white};
    font-size: .625rem;
    display: flex;
  }
`;

export const AttributesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
`;
